<template>
<el-card shadow="never" :body-style="{ padding: '20px' }" class="mb-4 mx-auto">
    <div class="mx-auto p-1 text-gray-600">
        <h2 class="text-2xl mb-4">FAQ</h2>
        <div class="mb-4">
            <h3 class="font-bold mb-1">What is Eporner Downloader?</h3>
            <p>
                Eporner Downloader is a free Chrome extension that allows you to download videos from Eporner for offline viewing. Save your favorite content directly to your device in high quality.
            </p>
        </div>

        <div class="mb-4">
            <h3 class="font-bold mb-1">How does Eporner Downloader work?</h3>
            <p>
                Eporner Downloader uses a browser extension to detect and extract video URLs from Eporner pages. Simply copy the video link, paste it into the downloader interface, and the extension will find the downloadable video files.
            </p>
        </div>

        <div class="mb-4">
            <h3 class="font-bold mb-1">Do I need to install any software?</h3>
            <p>
                No additional software is required beyond the Chrome extension. Everything runs directly in your browser, making it lightweight and easy to use without consuming system resources.
            </p>
        </div>

        <div>
            <h3 class="font-bold mb-1">What formats are supported by Eporner Downloader?</h3>
            <p>
                Eporner Downloader supports downloading videos in MP4 format, which is compatible with virtually all devices and media players. Videos are saved in their original resolution and quality.
            </p>
        </div>
    </div>
</el-card>
</template>

<script>
export default {

}
</script>

<style>

</style>
